module.exports = __webpack_public_path__ + "img/account.e8bd7ee4.svg";